import { render, staticRenderFns } from "./zh_zyhl.vue?vue&type=template&id=0be28b14&"
import script from "./zh_zyhl.vue?vue&type=script&lang=js&"
export * from "./zh_zyhl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports